module.exports = __webpack_public_path__ + "media/react-view-today@sm-cda259653916d0074d6a6edf35afb47f.jpg";